const ISO_CURRENCY_PATTERN = /^[A-Z]{3}$/;

export const deriveCurrencyFromLocale = locale => {
  const normalized = `${locale || ''}`.toLowerCase();
  if (normalized.startsWith('pt')) {
    return 'BRL';
  }

  return 'USD';
};

export const resolveCrmCurrency = account => {
  const configured = `${account?.settings?.crm_currency || ''}`
    .trim()
    .toUpperCase();
  if (configured && ISO_CURRENCY_PATTERN.test(configured)) {
    return configured;
  }

  return deriveCurrencyFromLocale(account?.locale);
};

export const toCurrencyCents = value => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed) || parsed < 0) {
    return null;
  }

  return Math.round(parsed * 100);
};

export const fromCurrencyCents = valueCents => {
  if (valueCents === null || valueCents === undefined || valueCents === '') {
    return '';
  }

  const parsed = Number(valueCents);
  if (Number.isNaN(parsed)) {
    return '';
  }

  return (parsed / 100).toFixed(2);
};

export const formatCurrencyFromCents = ({
  valueCents,
  currency = 'USD',
  locale = 'en',
}) => {
  if (valueCents === null || valueCents === undefined || valueCents === '') {
    return null;
  }

  const parsed = Number(valueCents);
  if (Number.isNaN(parsed)) {
    return null;
  }

  const normalizedLocale = `${locale || 'en'}`.replace('_', '-');
  const normalizedCurrency = `${currency || 'USD'}`.toUpperCase();
  const safeCurrency = ISO_CURRENCY_PATTERN.test(normalizedCurrency)
    ? normalizedCurrency
    : 'USD';

  return new Intl.NumberFormat(normalizedLocale, {
    style: 'currency',
    currency: safeCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parsed / 100);
};
